import React, { useEffect, useRef } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { Grid } from "@mui/material";
import "../CustomInputLogin/CustomInputLogin.css";
import { ImportantDevices } from "@mui/icons-material";
import { FaStarOfLife } from "react-icons/fa6";

const CustomIsCurrentorNotFromToDate = ({ label1, label2, important, showToDate = true }) => {
  const { values, setFieldValue } = useFormikContext();

  const fromDateMax = values.toDate || undefined;
  const toDateMin = values.fromDate || undefined;

  const fromDateRef = useRef(null);
  const toDateRef = useRef(null);

  const handleFromClick = () => {
    if (fromDateRef.current) {
      fromDateRef.current.showPicker?.(); // Modern browsers
      fromDateRef.current.focus();        // Fallback
    }
  };

  const handleToClick = () => {
    if (toDateRef.current) {
      toDateRef.current.showPicker?.();
      toDateRef.current.focus();
    }
  };

  const handleFromDateChange = (e) => {
    const selectedDate = e.target.value;


    setFieldValue("fromDate", selectedDate);
    if (values.toDate && new Date(values.toDate) < new Date(selectedDate)) {
      setFieldValue("toDate", null);
    }
  };

  const handleToDateChange = (e) => {
    const selectedDate = e.target.value;

    setFieldValue("toDate", selectedDate);
    if (values.fromDate && new Date(selectedDate) < new Date(values.fromDate)) {
      setFieldValue("fromDate", null);
    }
  };

  useEffect(() => {
    if (!showToDate) {
      setFieldValue("toDate", null);
    }
  }, [showToDate, setFieldValue]);


  return (
    <>
      <Grid
        size={{ xs: 12, md: 6, sm: 6 }}
      // item md={4} xs={12} sm={6}
      >
        <label
          htmlFor="fromDate"
          className="input-heading12"
          style={{ fontSize: "15px", fontWeight: "450", display: "block", marginBottom: "6px" }}
        >
          {label1}
          {important && (
            <FaStarOfLife style={{ color: '#F53E5C', fontSize: "8px", marginLeft: "3px", marginBottom: "4px" }} />
          )}
        </label>
        <Field
          onClick={handleFromClick}
          ref={fromDateRef}

          id="fromDate"
          name="fromDate"
          type="date"
          max={fromDateMax}
          onChange={handleFromDateChange}
          style={{ width: "96%", padding: "3px 3px 3px 10px", fontSize: "16px" }}
          className="custominputData-field12"
        />
        <ErrorMessage
          name="fromDate"
          component="div"
          className="inputs-error-msg"
          style={{ color: "red", fontSize: "12px" }}
        />
      </Grid>

      {showToDate && (
        <Grid
          // item md={4} xs={12} sm={6}
          size={{ xs: 12, md: 6, sm: 6 }}
        >
          <label
            htmlFor="toDate"
            className="input-heading12"
            style={{ fontSize: "15px", fontWeight: "450", display: "block", marginBottom: "5px" }}
          >
            {label2}
            {important && (
              <FaStarOfLife style={{ color: '#F53E5C', fontSize: "8px", marginLeft: "3px", marginBottom: "4px" }} />
            )}
          </label>
          <Field
            onClick={handleToClick}
            ref={toDateRef}
            id="toDate"
            name="toDate"
            type="date"
            min={toDateMin}
            onChange={handleToDateChange}
            style={{ width: "96%", padding: "3px 3px 3px 10px", fontSize: "16px" }}
            className="custominputData-field12"
          />
          <ErrorMessage
            name="toDate"
            component="div"
            className="inputs-error-msg"
            style={{ color: "red", fontSize: "12px" }}
          />
        </Grid>
      )}
    </>
  );
};

export default CustomIsCurrentorNotFromToDate;
